import React from 'react'
import classnames from 'classnames'
import {Map} from 'immutable'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import * as Links from '../../../../shared_components/Links'
import SessionStore from '../../../../auth/src/stores/SessionStore'
import {proBrandingResolved, proBrandName, usesFuneralHomeBranding} from '../../lib/firmTools'
import {findRawResourceById} from '../../../../lib/plan_data/userData'

import './footer.scss'

export const Footer = ({currentUser = {}, firm = Map(), sessionInitialized = false, whitelist = []}) => {
  if (whitelist.some(path => window.location.hash.match(path)))
    return <div />

  const brandingResolved = proBrandingResolved({currentUser, firm, sessionInitialized})

  const funeralHomeBranding = usesFuneralHomeBranding({
    isConcierge: currentUser.quarterback,
    firm
  })

  return (
    <footer>
      <div className='pro-footer-wrapper'>
        <nav>
          <ul className='footer-menu'>
            <li className='footer-menu-item'><Links.ProHelp target='_blank' /></li>
            <li className='footer-menu-item'><Links.ContactUs target='_blank' /></li>
            <li className='footer-menu-item'><Links.Terms target='_blank' /></li>
            <li className='footer-menu-item'><Links.Privacy target='_blank' /></li>
          </ul>
        </nav>
        <div>
          <ul>
            <li><hr /></li>
            <li>
              <span
                className={
                  classnames('branding', {
                    'funeral-home': funeralHomeBranding,
                    pending: !brandingResolved
                  })
                }>
                {brandingResolved ? proBrandName(funeralHomeBranding) : ''}
              </span>
            </li>
          </ul>
        </div>
        <div className='copyright'><p>&copy; {new Date().getFullYear()} Everplans</p></div>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  currentUser: PropTypes.object,
  firm: PropTypes.instanceOf(Map),
  sessionInitialized: PropTypes.bool,
  whitelist: PropTypes.arrayOf(PropTypes.string)
}

const mapStateToProps = (state, ownProps) => ({
  firm: findRawResourceById({
    rawResource: state.api.firms,
    id: ownProps.currentUser?.firm
  })
})

const ConnectedFooter = connect(mapStateToProps)(Footer)

export default class ProFooterController extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentUser: this.currentUser() || {},
      sessionInitialized: SessionStore.initialized()
    }

    this.onUpdate = this.onUpdate.bind(this)
  }

  componentDidMount() { SessionStore.addChangeListener(this.onUpdate) }

  componentWillUnmount() { SessionStore.removeChangeListener(this.onUpdate) }

  onUpdate() {
    this.setState({
      currentUser: this.currentUser() || {},
      sessionInitialized: SessionStore.initialized()
    })
  }

  currentUser() { return SessionStore.getState().currentUser }

  render() {
    return (
      <ConnectedFooter
        currentUser={this.state.currentUser}
        sessionInitialized={this.state.sessionInitialized}
        whitelist={this.props.whitelist}
      />
    )
  }
}

ProFooterController.propTypes = {whitelist: PropTypes.arrayOf(PropTypes.string)}
